export const LeftPathways = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="642"
      height="962"
      viewBox="0 0 642 962"
      fill="none"
    >
      <path
        d="M1 1L241 1.00007V81.0001M241 322V480M401 641V481L481 401M241 721L241 961M241 961L401 801.001M241 961L1 961M321 81.0001H1M321 81.0001L81 321M321 81.0001L401 161M401 161L1 161M401 161L81 481L241 641M401 161V241L481 321M481.001 241H2M481 321H1M481 321V401.064M481 721L561 641M481 721L1 721M481 721L321 561.001M561 641L1 641M561 641L241 321M480.999 401H1M481 561.001L561 481.001L321 241M641 481H1M482 561H1M480.999 241L320.999 401M241 241L81 81M321 561.001L81.0015 801M321 561.001V721.001L401 801.001M82 641L242 481M401 801.001L1 801M241 881L161 801M161 881L241 801M81.5 160.5L240.5 1.5M321 881H1"
        stroke="var(--brand-color-salmon-5, #ED8565)"
        strokeLinecap="round"
      />
    </svg>
  );
};

export const RightPathways = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="642"
      height="962"
      viewBox="0 0 642 962"
      fill="none"
    >
      <path
        d="M641 961H480.5L80.5 561L80.5 401L480.5 1L641.002 1.00006M400.5 881H641M320.5 801H641M240.5 721H641M160.5 641H641M81 561L641 561M1 481H641M81 401L641 401M160.5 321H641M240.5 241H641M321 161L641 161M400.5 81.0001H641"
        stroke="var(--brand-color-purple-6, #915EFF)"
        strokeLinecap="round"
      />
    </svg>
  );
};
